import React, { useState, useEffect } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab,  Modal } from "react-bootstrap";
import {
  get_UserData, get_CategoryRedirect,get_UserSingleData

} from "../../../store/actions/CommanAction";

import { useDispatch, useSelector } from "react-redux";
import { setAstroId } from "../../../store/Action_Types";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";
import useResizableColumns from "../Utility/useResizableColumns";

const UserList = () => {
  const dispatch = useDispatch();
  const AstroData = useSelector((state) => state.feedBackReducer.UserData);
 
  const CategoryNotificationData = useSelector(
    (state) => state.feedBackReducer?.CategoryRedirectData ?? []
  );
  const filterdata = CategoryNotificationData?.map((item) => item.Name);

  const SingleUserData = useSelector(
    (state) => state.feedBackReducer.SingleUserData
  );

  const customerID = Number(sessionStorage.getItem("ID"));

 
  const [IsActive, setIsActive] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [AstrologerID, seAstrologerID] = useState("");

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [usereditModel, setUserEditModel] = useState(false);

  const [mobileNumber, setMobileNumber] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setloading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [amount, setAmount] = useState("");
  const [currentamount, setCurrentAmount] = useState(0);
  const [id, setId] = useState("");
  const [userdata, setUserData] = useState([]);
  const [editvalue, setEditValue] = useState("");
  const [username, setusername] = useState("");
  const [usermobileno, setUsermoileno] = useState("");

  const [showWalletModal, setShowWalletModal] = useState(false);
  const [activeTab, setActiveTab] = useState("wallet");
  const [selectedUser, setSelectedUser] = useState(null);
  const [walletData, setWalletData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [usersid, setUsersid] = useState("")
  const [freeChatModel, setFreeChatModel] = useState(false)

  //send notifications
  const [postModel, setPostModel] = useState(false);

  const [id1, setId1] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [gender, setGender] = useState("");


  useEffect(() => {
    dispatch(get_CategoryRedirect("1"));
  }, []);

  const handleAddAstrologerClick = (ID) => {
    dispatch(setAstroId(ID));
  };
  const isSingleRow = userdata?.length === 1;
  useEffect(() => {
    seAstrologerID(AstrologerID);
  }, [AstrologerID]);

  useEffect(() => {
    setUserData(AstroData);
  }, [AstroData]);
  useEffect(() => {
    if (IsActive) {
      const today = new Date();
      const formattedToday = today.toISOString().split("T")[0];
      const CreatedFrom = formattedToday;
      const CreatedTo = formattedToday;
      const IsActive = "1";
      setStartTime(CreatedFrom);
      setEndTime(CreatedTo);

      dispatch(get_UserData(setloading, IsActive, CreatedFrom, CreatedTo));
    } else {
      const today = new Date();
      const formattedToday = today.toISOString().split("T")[0];
      const CreatedFrom = formattedToday;
      const CreatedTo = formattedToday;
      const IsActive = "0";
      setStartTime(CreatedFrom);
      setEndTime(CreatedTo);

      dispatch(get_UserData(setloading, IsActive, CreatedFrom, CreatedTo));
    }
  }, []);

  const filteredAstroData = AstroData?.filter((item) => {
    const query = searchQuery ? searchQuery.toLowerCase() : "";
    return (
      (item.DisplayName && item.DisplayName.toLowerCase().includes(query)) ||
      (item.EMPID && item.EMPID.toLowerCase().includes(query)) ||
      (item.RegMobileNo && item.RegMobileNo.toLowerCase().includes(query)) ||
      (item.EmailID && item.EmailID.toLowerCase().includes(query))
    );
  });
  useEffect(() => {
    if (editvalue && editvalue.length > 0) {

      setGender(editvalue[0]?.Gender);
      setUsermoileno(editvalue[0]?.POB);
    }
  }, [editvalue]);

  useEffect(() => {
    if (name.length < 3 && location.length < 3 && mobileNumber < 3) return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(
        get_UserData(
          setloading,
          IsActive,
          startTime,
          endTime,
          name,
          mobileNumber,
          location
        )
      );
      setloading(false);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [name, location, mobileNumber]);

  const handleToggleStatusClick = async (
    UserID,
    currentIsBlock,
    currentStatus
  ) => {
    const postData = {
      UserID: UserID,
      IsBlock: !currentStatus ? "1" : "0",
      BlockReason: null,
      
    };

    await AddUpdate("User/Update_UserBlockStatus", postData);

    if (
      !name.trim() &&
      !mobileNumber.trim() &&
      !location.trim() &&
      !startTime &&
      !endTime
    ) {
   
      return;
    }

    if (mobileNumber.trim() && !/^\d{10}$/.test(mobileNumber)) {
      alert("Mobile number must be exactly 10 digits and numbers.");
      return;
    }

    if (name.trim() && !/^[a-zA-Z\s]+$/.test(name.trim())) {
      alert("Name must be in a valid string format.");
      return;
    }

    if (location.trim() && !/^[a-zA-Z\s]+$/.test(location.trim())) {
      alert("Location must be in a valid string format.");
      return;
    }

    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);
    const CreatedFrom = formattedStartDate;
    const CreatedTo = formattedEndDate;

    dispatch(
      get_UserData(
        setloading,
        currentStatus ? "1" : "0",
        CreatedFrom,
        CreatedTo,
        name,
        mobileNumber,
        location
      )
    );

    swal(
      "Success",
      `${!currentIsBlock ? "User has been blocked" : "User has been unblocked"
      }`,
      "success"
    );
  };


  const Inactivefunction = async (
    UserID,
    currentStatus
  ) => {
    const postData = {
      UserID: UserID
    };

    await AddUpdate("User/Update_UsersMobileNo", postData);

    if (
      !name.trim() &&
      !mobileNumber.trim() &&
      !location.trim() &&
      !startTime &&
      !endTime
    ) {

      return;
    }

    if (mobileNumber.trim() && !/^\d{10}$/.test(mobileNumber)) {
      alert("Mobile number must be exactly 10 digits and numbers.");
      return;
    }

    if (name.trim() && !/^[a-zA-Z\s]+$/.test(name.trim())) {
      alert("Name must be in a valid string format.");
      return;
    }

    if (location.trim() && !/^[a-zA-Z\s]+$/.test(location.trim())) {
      alert("Location must be in a valid string format.");
      return;
    }

    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);
    const CreatedFrom = formattedStartDate;
    const CreatedTo = formattedEndDate;

    dispatch(
      get_UserData(
        setloading,
        currentStatus ? "1" : "1",
        CreatedFrom,
        CreatedTo,
        name,
        mobileNumber,
        location
      )
    );

    swal(
      "Success",
      `User Successfully Inactive`,
      "success"
    );
  };


  const PriceAdd = (id) => {
    setAmount();
    setId(id);
    const filterdata = userdata.filter((item) =>
      item.UserID == id ? item.WalletAmt : ""
    );
    const currentamout = filterdata?.map((item) => item?.WalletAmt);
    setCurrentAmount(currentamout);
    setEditModal(true);
  };
  

  const Amoutadd = async () => {
    let error = false;
    let errormsg = "";

    if (!amount?.trim()) {
      error = true;
      errormsg = "Please fill the field";
      swal("Error", errormsg, "error");
      return;
    }

    const insertdata = {
      WalletAmt: amount.trim(),
      ModifiedByUser: customerID,
      UserID: id,
    };

    try {
      await AddUpdate("Users/Update_Wallet", insertdata);
      dispatch(
        get_UserData(
          setloading,
          IsActive,
          startTime,
          endTime,
          name,
          mobileNumber,
          location
        )
      );
      swal("Good job!", "Successfully Inserted", "success");
      setEditModal(false);
    } catch (err) {
      swal("Error", "Something went wrong while updating.", "error");
    }
  };

  const updatefreechat = async () => {
    let error = false;
    let errormsg = "";



    const insertdata = {
      LoginState: amount,
      UserID: id,
    };

    try {
      await AddUpdate("User/Update_LoginState", insertdata);
      dispatch(
        get_UserData(
          setloading,
          IsActive,
          startTime,
          endTime,
          name,
          mobileNumber,
          location
        )
      );
      swal("Good job!", "Successfully updated", "success");
      setFreeChatModel(false);
    } catch (err) {
      swal("Error", "Something went wrong while updating.", "error");
    }
  };

  const handleSearch = (IsActive, validate = true) => {
    if (validate) {
      if (
        !name.trim() &&
        !mobileNumber.trim() &&
        !location.trim() &&
        !startTime &&
        !endTime
      ) {
        alert(
          "Please provide at least one of Name, Mobile Number, or Location."
        );
        return;
      }

      if (mobileNumber.trim() && !/^\d{10}$/.test(mobileNumber)) {
        alert("Mobile number must be exactly 10 digits and numbers.");
        return;
      }

      if (name.trim() && !/^[a-zA-Z\s]+$/.test(name.trim())) {
        alert("Name must be in a valid string format.");
        return;
      }

      if (location.trim() && !/^[a-zA-Z\s]+$/.test(location.trim())) {
        alert("Location must be in a valid string format.");
        return;
      }
    }

    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };
    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);
    const CreatedFrom = formattedStartDate;
    const CreatedTo = formattedEndDate;

    dispatch(
      get_UserData(
        setloading,
        IsActive,
        CreatedFrom,
        CreatedTo,
        name,
        mobileNumber,
        location,
        usersid
      )
    );
  };
  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
    setMobileNumber("");
    setName("");
    setLocation("");
    setUsersid("")
  };
  function UserEdit(id) {
    setId(id);
    dispatch(get_UserSingleData(id));
    setEditValue(SingleUserData)
    setUserEditModel(true);
  }

  useEffect(() => {
    if (SingleUserData) {
      setGender(SingleUserData.Gender || "");
      setUsermoileno(SingleUserData.POB || "");
    }
    setEditValue(SingleUserData);
  }, [SingleUserData]);

  const updateuser = async () => {
    const val = {
      Gender: gender,
      POB: usermobileno,
      UserID: id,
    };
    await AddUpdate("User/Update_User", val);
    setUserEditModel(false);
    swal("Good job!", "Successfully updated", "success");
    dispatch(get_UserData(setloading, IsActive, startTime, endTime));
  };

  const fetchWalletData = async (userId) => {
    try {
      const res1 = await AddUpdate("HomePage/GetData_UserWalletTransaction", {
        UserID: userId,
      });

      let finaldata = JSON.parse(res1.data?.data);
      setWalletData(finaldata.Table || []);
    } catch (err) {
      console.error("Wallet fetch error:", err);
    }
  };

  const fetchPaymentData = async (userId) => {
    try {
      const res = await AddUpdate("HomePage/GetData_PaymentHistory", {
        UserID: userId,
      });

      let finaldata = JSON.parse(res.data?.data);
      setPaymentData(finaldata.Table || []);
    } catch (err) {
      console.error("Payment fetch error:", err);
    }
  };

  const handleOpenWalletModal = async (row) => {

    setSelectedUser(row);
    setShowWalletModal(true);
    setWalletData([]);
    setPaymentData([]);
    setActiveTab("wallet");
    await fetchWalletData(row.UserID);
    await fetchPaymentData(row.UserID);
  };



  const columns = [
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Dropdown drop="up">
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" renderOnMount popperConfig={{ strategy: "fixed" }} className="dropdown-menu-right" s
            >
 
              <Dropdown.Item
                className={row.IsBlock ? "text-success" : "text-danger"}
                onClick={() =>
                  handleToggleStatusClick(row.UserID, row.IsBlock, true)
                }
              >
                {row.IsBlock ? "Unblock" : "Block"}
              </Dropdown.Item>

              <Dropdown.Item
                style={{ color: "black" }}
                onClick={() =>
                  Inactivefunction(row.UserID)
                }
              >
                {row.IsActive ? "User Inactive" : "User Inactive"}
              </Dropdown.Item>


              <Dropdown.Item
                style={{ color: "black" }}
                onClick={() => PriceAdd(row.UserID, true)}
              >
                Add Recharge Amount
              </Dropdown.Item>
              <Dropdown.Item
                style={{ color: "black" }}
                onClick={() => Freechat(row.UserID, true)}
              >
                Free Chat
              </Dropdown.Item>
              <Dropdown.Item
                style={{ color: "black" }}
                onClick={() => sendnotification(row.UserID, true)}
              >
                Send Notification
              </Dropdown.Item>
              <Dropdown.Item style={{color:"black"}} onClick={()=>UserEdit(row.UserID)}>
                Edit User Details
              </Dropdown.Item>


            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      width: "100px"
    },
    {
      name: "Name",
      selector: (row) => row.NickName,
      sortable: true,
     
      cell: (row) => (
        <div
          onClick={() => handleOpenWalletModal(row)}
          style={{ cursor: "pointer" }}
        >
          <div>
            {row.NickName}({row.UserID})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.MobileNo}
          </div>
        </div>
      ),
    },

    {
      name: "WalletAmt",
      selector: (row) => row.WalletAmt,
      sortable: true,
      
    },
    {
      name: "Medium",
      selector: (row) => row.Medium,
      sortable: true,
      
    },
    {
      name: "Calls",
      selector: (row) => row.TotalCalls,
      sortable: true,
      
    },
    {
      name: "Chats",
      selector: (row) => row.TotalChats,
      sortable: true,
  
    },
    {
      name: "Pending(chat/call)",
      selector: (row) => row.TotalPending,
      sortable: true,
     
    },


    {
      name: "Created Date",
      selector: (row) => {
        if (!row.CreatedTime) return "-";
        const date = new Date(row.CreatedTime);
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",

          hour12: true,
        });
      },
      sortable: true,
     

    },
    {
      name: "Last SignIn Time",
      selector: (row) => {
        if (!row.LastSignInTime) return "-";
        const date = new Date(row.LastSignInTime);
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",

          hour12: true,
        });
      },
      sortable: true,
    }, {
      name: "Gender",
      selector: (row) => row.Gender,
      sortable: true,
     
      cell: (row) => (
        <div style={{ paddingBottom: isSingleRow ? "30px" : "10px" }}>
          {row.Gender}
        </div>
      ),
    },
    {
      name: "Address ",
      selector: (row) => row.POB,
    }

  ];

 

  const resizeableColumns = useResizableColumns(columns);

  

const conditionalRowStyles = [
  {
    when: row => row.IsActive === false,  
    style: {
      backgroundColor: '#f78888ff',
       "&:hover": {
        backgroundColor: '#f78888ff', 
      },
    
    },
  },
];



  const columns1 = [
    {
      name: (
        <p
          className="text-end"
          style={{
            position: "absolute",
            top: "7px",
            right: 50,
            zIndex: "999999999999",
          }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown drop="up">
            <Dropdown.Toggle
              drop="up"
              variant=""
              as="div"
              className="btn-link i-false"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu
              drop="up"
              alignRight={true}
              className="dropdown-menu-right"
            >
              <Dropdown.Item
                className={row.IsBlock ? "text-success" : "text-warning"}
                onClick={() => {
                  handleToggleStatusClick(row.UserID, row.IsBlock, false);
                }}
              >
                {row.IsBlock ? "Unblock" : "Unblock"}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      width: "100px",
    },

    {
      name: "Name",
      selector: (row) => row.NickName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <div>
            {row.NickName}({row.UserID})
          </div>
          <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
            {row.MobileNo}
          </div>
        </div>
      ),
    },

    {
      name: "Wallet Amount",
      selector: (row) => row.WalletAmt,
      sortable: true,
      width: "150px",
    },
    {
      name: "Medium",
      selector: (row) => row.Medium,
      sortable: true,
      width: "150px",
    },
    {
      name: "Gender",
      selector: (row) => row.Gender,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div style={{ paddingBottom: isSingleRow ? "30px" : "10px" }}>
          {row.Gender}
        </div>
      ),
    },
    {
      name: "Address ",
      selector: (row) => row.CurrentAddress,
      sortable: true,
      width: "200px",
    },
    {
      name: " Created Date",
      selector: (row) => row.CreatedTime,
      sortable: true,
    },
    {
      name: " Last SignIn Time",
      selector: (row) => row.LastSignInTime,
      sortable: true,
    },
  ];

  const Freechat = (id) => {

    setAmount("");
    setId(id);
  

    setFreeChatModel(true)
  }
  const [notificatinredirectvalue, setNotificationredctvalue] = useState("");
  const sendnotification = (id) => {
    setTitle("");
    setMessage("");
    setNotificationredctvalue("");
    setId1(id);
    setPostModel(true)
  }
  const onchanges = (e) => {
    setNotificationredctvalue(e.target.value);
  };


  const handleSubmit = async () => {
    try {

      if (!title || !title.trim()) {
        swal("Missing Title", "Please enter a notification title.", "warning");
        return;
      }


      if (!message || !message.trim()) {
        swal("Missing Message", "Please enter a message for the notification.", "warning");
        return;
      }


      const postData = {
        Title: title.trim(),
        Body: message.trim(),
        UserID: id1,
        IsMail: false,
        IsNotification: true,
        ImageUrl: "",
        Redirect: notificatinredirectvalue.trim(),
        AstroId: 0,
      };


      const response = await AddUpdate("Notifications/Send_Notification", postData);


      if (response) {
        swal("Good job!", "Notification sent successfully!", "success");
        setPostModel(false);
      } else {
        swal("Error", response?.message || "Failed to send notification.", "error");
      }

    } catch (error) {
      console.error("Error sending notification:", error);
      swal("Error", "Something went wrong while sending the notification.", "error");
    }
  };


  return (
    <>
      <div className="form-group main_card">
        <div className="row align-items-center">
          <div className="col-2">
            <h2 style={{ color: "#f7931e", fontWeight: 700 }}>User List</h2>
          </div>

          <div className="col-10">
            <div className="row">
              <div className="col-3">
                <label className="form-label">Start Time</label>
                <input
                  type="date"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </div>
              <div className="col-3">
                <label className="form-label">End Time</label>
                <input
                  type="date"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
              <div className="col-3">
                <label className="form-label">User Id</label>
                <input
                  type="test"
                  value={usersid}
                  placeholder="Enter User Id"
                  onChange={(e) => setUsersid(e.target.value)}
                />
              </div>

            </div>
            <div className="row align-items-center">
              <div className="col-3">
                <label className="form-label">Mobile Number</label>
                <input
                  type="text"
                  value={mobileNumber}
                  placeholder="Enter mobile number"
                  onChange={(e) => {
                    const input = e.target.value;

                    if (/^\d{0,10}$/.test(input)) {
                      setMobileNumber(input);
                    }
                  }}
                  maxLength={10}
                />
              </div>
              <div className="col-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  value={name}
                  placeholder="Enter name"
                  onChange={(e) => {
                    const input = e.target.value;

                    if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                      setName(input);
                    }
                  }}
                />
                {name.length > 0 && name.length < 3 && (
                  <span className="text-danger">
                    Name must be at least 3 characters
                  </span>
                )}
              </div>

              <div className="col-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  value={location}
                  placeholder="Enter location"
                  onChange={(e) => {
                    const input = e.target.value;

                    if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                      setLocation(input);
                    }
                  }}
                />
                {location.length > 0 && location.length < 3 && (
                  <span className="text-danger">
                    Location must be at least 3 characters
                  </span>
                )}
              </div>

              <div className="col-auto">
                <button
                  className="btn btn-primary mt-4 "
                  onClick={() => handleSearch(IsActive, true)}
                >
                  Search
                </button>
                <button
                  className="btn btn-secondary mt-4  ms-2"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

        </div>


      </div>

      <Tab.Container defaultActiveKey="All">
        <div className="main_card">
          <div className=" d-flex justify-content-between align-items-center flex-wrap ">
           
          </div>

          <Modal
            className="modal fade "
            show={editModal}
            onHide={setEditModal}
            backdrop="static"
          >
            <div className="" role="document">
              <div className="">
                <form>
                  <div className="modal-header">
                    <h4 className="modal-title fs-20">Add Recharge Amount</h4>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setEditModal(false)}
                      data-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body p-3">
                    <i
                      className="flaticon-cancel-12 close"
                      data-dismiss="modal"
                    ></i>
                    <div className="add-contact-box">
                      <div className="form-group">
                        <label className="form-label">New Amount</label>
                        <span className="text-danger star-error">*</span>

                        <input
                          type="number"
                          className="form-control"
                          name="comment"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter New Amount"
                          required
                        />
                      </div>
                    </div>
                    <div className="add-contact-box">
                      <div className="form-group">
                        <label className="form-label">Current Amount</label>

                        <input
                          type="number"
                          className="form-control"
                          name="comment"
                          defaultValue={0}
                          value={currentamount}
                          // onChange={(e) => setAmount(e.target.value)}
                          placeholder="0"
                          readOnly
                        />
                      </div>
                      .
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      style={{ color: "black" }}
                      onClick={() => {
                        Amoutadd();
                      }}
                      className="btn btn-success"
                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditModal(false);
                      }}
                      className="btn btn-danger"
                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <Modal
            className="modal fade "
            show={usereditModel}
            onHide={setUserEditModel}
            backdrop="static"
          >
            <div className="" role="document">
              <div className="">
                <form>
                  <div className="modal-header">
                    <h4 className="modal-title fs-20">User Edit Model</h4>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setUserEditModel(false)}
                      data-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body p-3">
                    <i
                      className="flaticon-cancel-12 close"
                      data-dismiss="modal"
                    ></i>
                 <div className="add-contact-box">
  <div className="form-group">
    <label className="form-label">Gender</label>
   <div className="d-flex align-items-center gap-3 mt-2">
  <div className="form-check">
    <input
      // className="form-check-input"
      type="radio"
      name="gender"
      id="male"
      value="Male"
      checked={gender === "Male"}
      onChange={(e) => setGender(e.target.value)}
    />
    <label className="form-check-label" htmlFor="male">
      Male
    </label>
  </div>

  <div className="form-check">
    <input
      // className="form-check-input"
      type="radio"
      name="gender"
      id="female"
      value="Female"
      checked={gender === "Female"}
      onChange={(e) => setGender(e.target.value)}
    />
    <label className="form-check-label" htmlFor="female">
      Female
    </label>
  </div>
</div>

  </div>
</div>

                    <div className="add-contact-box">
                      <div className="form-group">
                        <label className="form-label">Address</label>

                        <input
                          type="text"
                          className="form-control"
                          name="usermobileno"
                          defaultValue={0}
                          value={usermobileno}
                          onChange={(e) => setUsermoileno(e.target.value)}
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      style={{ color: "black" }}
                      disabled={! gender || !usermobileno }
                      onClick={() => {
                        updateuser();
                      }}
                      className="btn btn-success"
                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setUserEditModel(false);
                      }}
                      className="btn btn-danger"
                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <Modal
            show={showWalletModal}
            onHide={() => setShowWalletModal(false)}
            size="lg"
          >
            <Modal.Header style={{ color: "red" }} closeButton>
              <Modal.Title>
                {selectedUser?.NickName} ({selectedUser?.UserID}){" "}
                <div>Available Balance: {selectedUser?.WalletAmt}</div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
      <Nav.Item>
        <Nav.Link eventKey="wallet">Wallet Transactions</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="payment">Payment Logs</Nav.Link>
      </Nav.Item>
    </Nav> */}

              <div style={{ color: "black" }} className="mt-3 row">
                <div
                  className="col-md-7"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    border: "1px solid black",
                  }}
                >
                  <h5 style={{ color: "#F7931E", fontWeight: "bold" }}>
                    Wallet Transactions
                  </h5>
                  {walletData.length > 0 ? (
                    walletData.map((item, idx) => (
                      <div
                        key={idx}
                        style={{
                          borderBottom: "1px solid #ddd",
                          padding: "10px 0",
                        }}
                      >
                        <div>{item.Description}</div>
                        <div style={{ fontSize: "12px", color: "black" }}>
                          Order Id: {item.ID} <br />
                          {item.TransactionDateTime}
                        </div>
                        <div
                          style={{
                            color: String(item.Amt).includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {String(item.Amt).includes("-")
                            ? `${item.Amt}`
                            : `+ ₹${item.Amt}`}
                        </div>
                        <div>{item.GSTAmt > 0 && `GST: ${item.GSTAmt}`}</div>
                      </div>
                    ))
                  ) : (
                    <p>No wallet transactions found.</p>
                  )}
                </div>

                <div
                  className="col-md-5"
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    border: "1px solid black",
                  }}
                >
                  <h5 style={{ color: "#f0860cff", fontWeight: "bold" }}>
                    Payment Logs
                  </h5>
                  {paymentData.length > 0 ? (
                    paymentData.map((item, idx) => (
                      <div
                        key={idx}
                        style={{
                          borderBottom: "1px solid #ddd",
                          padding: "10px 0",
                        }}
                      >
                        <div>{item.payment_description}</div>
                        <div style={{ fontSize: "12px", color: "black" }}>
                          Order Id: {item.order_id} <br />
                          {item.CreatedDate}
                        </div>
                        <div
                          style={{
                            color: String(item.payment_amount).includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {String(item.payment_amount).includes("-")
                            ? `${item.payment_amount}` // already negative
                            : `+ ₹${item.payment_amount}`}
                        </div>

                        <div>{item.GstAmt > 0 && `Gst :${item.GstAmt}`}</div>
                      </div>
                    ))
                  ) : (
                    <p>No payment logs found.</p>
                  )}
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            className="modal fade "
            show={freeChatModel}
            onHide={setFreeChatModel}
            backdrop="static"

          >
            <div className="" role="document">
              <div className="">
                <form>
                  <div className="modal-header">
                    <h4 className="modal-title fs-20">Free Chat</h4>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setFreeChatModel(false)}
                      data-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body p-3">
                    <i
                      className="flaticon-cancel-12 close"
                      data-dismiss="modal"
                    ></i>
                    <div className="add-contact-box">
                      <div className="form-group">
                        <label className="form-label">Free Chat </label>

                        <div className="d-flex gap-4 mt-2">
                          <label className="d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              // className="form-check-input"
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                              checked={amount === true}
                              onChange={() => setAmount(true)}
                            />
                            <span>Not Free</span>
                          </label>

                          <label className="d-flex align-items-center gap-2">
                            <input
                              type="checkbox"
                              // className="form-check-input"
                              style={{ width: "18px", height: "18px", cursor: "pointer" }}
                              checked={amount === false}
                              onChange={() => setAmount(false)}
                            />
                            <span>Free</span>
                          </label>
                        </div>
                      </div>
                    </div>





                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      style={{ color: "black" }}
                      onClick={() => {
                        updatefreechat();
                      }}
                      className="btn btn-success"

                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setFreeChatModel(false);
                      }}
                      className="btn btn-danger"
                    >
                      {" "}
                      <i className="flaticon-delete-1"></i> Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>


          <Modal
            className="modal fade"
            size="xl"
            show={postModel}
            onHide={() => setPostModel(false)}
            backdrop="static"
          >
            <div className="row g-0">

              <div className="col-md-6 p-4">
                <div
                  className="shadow"
                  style={{ borderRadius: "12px", border: "1px solid #e5e7eb" }}
                >
                  <div style={{ padding: "1.5rem" }}>
                    <h5 className="mb-4 fw-bold" style={{ fontSize: "20px" }}>
                      Create Notification
                    </h5>


                    <div className="mb-3">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Notification Title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    </div>


                    <div className="mb-3">
                      <div className="form-group">
                        <textarea
                          placeholder="Enter your message..."
                          rows="4"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </div>
                    </div>



                    <div className="mb-3">
                      <div className="form-group">
                        <select onChange={onchanges}>
                          <option disabled selected value="">
                            Notification Redirect
                          </option>
                          {filterdata?.map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>




                    <div className="d-flex justify-content-end mt-2">
                      <button
                        className="btn me-2"
                        style={{
                          backgroundColor: "#ff6f00",
                          color: "#fff",
                          fontWeight: 600,
                          width: "150px",
                        }}
                        onClick={handleSubmit}
                      >
                        Send Notification
                      </button>

                      <button
                        className="btn"
                        style={{
                          backgroundColor: "red",
                          color: "#fff",
                          fontWeight: 600,
                          width: "150px",
                        }}
                        onClick={() => setPostModel(false)}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="col-md-6 d-flex align-items-center justify-content-center"
                style={{ background: "#f9fafb", borderLeft: "1px solid #ddd" }}
              >
                <div
                  style={{
                    width: "350px",
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "15px",
                    background: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >

                  <div className="d-flex justify-content-between align-items-center">
                    <div
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >

                      AstroCall
                    </div>
                    <span style={{ cursor: "pointer" }}>×</span>
                  </div>


                  <div style={{ fontSize: "14px", marginTop: "8px" }}>
                    <strong>{title || "Notification Title"}</strong>
                  </div>


                  <div style={{ fontSize: "13px", color: "#555" }}>
                    {message || "Your message will appear here..."}
                  </div>
                </div>
              </div>
            </div>
          </Modal>


          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body p-0">
                  <Tab.Content>
                    <Tab.Pane eventKey="All">
                      <div className="table-responsive">
                        {IsActive ? (
                          <>
                            {loading ? (
                              <Loader />
                            ) : (
                              <DataTable
                                dense
                                columns={resizeableColumns}
                                data={AstroData}
                                selectableRowsHighlight
                                highlightOnHover
                                pagination
                                persistTableHead={true}
                                  conditionalRowStyles={conditionalRowStyles}
                                noDataComponent={"There are no data to display"}
                                customStyles={customStyles}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {loading ? (
                              <Loader />
                            ) : (
                              <DataTable
                                dense
                                data={AstroData}
                                columns={columns1}
                                pagination
                                persistTableHead={true}
                                noDataComponent={"There are no data to display"}
                                customStyles={customStyles}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default UserList;
